module.exports = __webpack_public_path__ + "img/mastercard.5365d11c.svg";